import { getService } from '@Client/runner.hooks/useService';
import React from 'react';

interface RunnerPageDescriptionProps {
  showText?: boolean;
  pageDescription?: string;
  helpLink?: string;
  pageHeaderText?: string;
  backLinkText?: string;
  backLinkState?: string;
  children?: React.ReactNode;
}

export function RunnerPageDescription({
  showText = true,
  pageDescription = '',
  helpLink = '',
  pageHeaderText = '',
  backLinkText = '',
  backLinkState = '',
  children
}: RunnerPageDescriptionProps) {
  const brandingService = getService('brandingService');
  const brandedHelpLink = helpLink
    ? brandingService.getBrandedHelpUri(helpLink)
    : '';

  const handleBackClick = () => {
    if (backLinkState) {
      const $state = getService('$state');
      $state.go(backLinkState);
    }
  };

  return (
    <>
      {backLinkText && (
        <div className="user-menu__back-button">
          <div onClick={handleBackClick}>
            <i
              id="back-button"
              className="fa-light fa-arrow-left"
              aria-hidden="true"
            ></i>
            <span className="user-menu__back-text">{backLinkText}</span>
          </div>
        </div>
      )}
      <div className="page-header-description__top-space"></div>
      {showText && (
        <div className="page-header-description_wrapper">
          <div className="page-header-description">
            <div className="page-header-component">
              <h4 className="runner-page-header">{pageHeaderText}</h4>
              <div className="page-header-description__text">
                {pageDescription}
              </div>
              {brandedHelpLink && (
                <div className="page-header-description__help-link">
                  <a
                    href={brandedHelpLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more.
                  </a>
                </div>
              )}
            </div>
            <div className="page-header-description__contents">
              <div className="page-header-description__actions">{children}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
